module.exports = __webpack_public_path__ + "img/case-bj22.2638afd0.png";